<mat-menu #typeMenu="matMenu">
  <ng-template matMenuContent>
    @for (type of groupTypes; track type) {
      @if (group.type !== type) {
        <button mat-menu-item (click)="changeType(type)">
          <span class="capitalize">{{ type }}</span>
        </button>
      }
    }
  </ng-template>
</mat-menu>
<div class="button-spacer">
  <button mat-stroked-button [matMenuTriggerFor]="typeMenu">
    <span class="capitalize">{{ group.type }}</span>
  </button>
</div>

<span class="mat-caption flex-1">{{ description }}</span>
<button mat-icon-button color="warn" (click)="deleted.emit()">
  <mat-icon>delete</mat-icon>
</button>
